const attendeeDefault = {
  name: '',
  email: '',
  cellPhone: '',
  badgename: '',
  speciality: '',
  aceptTerms: false,
  marketingTerms1: false,
  marketingTerms2: false,
  cancelTerms: false,
  complianceTerms: false,
};

const cctokenDefault = {
  number: '',
  name: '',
  country: '',
  expireAt: '',
  code: '',
  installments: 1,
};

const customerDefault = {
  name: '',
  email: '',
  cellPhone: '',
  address: '',
};

const transactionDefault = {
  promoCode: 'NOCODE',
  eventId: process.env.REACT_APP_EVENT_ID,
  eventCode: 136785,
  attendees: [],
  products: [],
  paymentType: 'pix',
  customer: null,
  token: '',
  installments: 1,
};
const transactionResponseDefault = { success: false, data: null };

const loginDefault = {
  document: '',
  eventId: process.env.REACT_APP_EVENT_ID,
};

export {
  attendeeDefault,
  cctokenDefault,
  customerDefault,
  transactionDefault,
  transactionResponseDefault,
  loginDefault,
};
